module.exports = __webpack_public_path__ + "static/img/reference_scale_female.39e5612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reference_scale_female.png
// module id = ejHf
// module chunks = 1